/*
 * Copyright (c) 2020 Little Robot Friends, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */

import 'firebase/compat/analytics'
import firebase from 'firebase/compat/app'
import 'firebase/compat/auth'
import 'firebase/compat/firestore'
import 'firebase/compat/functions'
import 'firebase/compat/performance'
import 'firebase/compat/storage'
import isEmpty from 'lodash/isEmpty'

const firebaseConfig = {
  apiKey: process.env.REACT_APP_API_KEY,
  authDomain: process.env.REACT_APP_AUTH_DOMAIN,
  databaseURL: process.env.REACT_APP_DATABASE_URL,
  projectId: process.env.REACT_APP_PROJECT_ID,
  storageBucket: process.env.REACT_APP_STORAGE_BUCKET,
  messagingSenderId: process.env.REACT_APP_MESSAGING_SENDER_ID,
  appId: process.env.REACT_APP_APP_ID,
  measurementId: process.env.REACT_APP_MEASUREMENT_ID,
}

// Initialize a Firebase app instance if not present
if (isEmpty(firebase.apps)) {
  firebase.initializeApp(firebaseConfig)
}

// Firebase Authentication
const auth = firebase.auth()

// Firebase Cloud Firestore
const db = firebase.firestore()

// Firebase Cloud Functions
const storage = firebase.storage()

// Performance Monitoring
const perf = firebase.performance()

// Google Analytics
const analytics = firebase.analytics()

export {firebase as default, analytics, auth, db, perf, storage}
